export function popupOpen() {
    const bodyBlock = $('body');
    const popupBlock = $('.popup-block');
    const popupOpenElement = '.popup-open';
    const popupCloseElement = '.popup-block .close';
    // var isIframe = popupBlock.contains('iframe');
    let videoElement;
    let videoElementSrc;
    function videoPause() { 
        if($(videoElement).prop("tagName") == 'video') {
            videoElement.pause(); 
        } else {
			$(videoElement).attr('src', '');
		}
    } 
    function videoPlay() { 
        if($(videoElement).prop("tagName") == 'video') {
			var source = $(videoElement).find('source');
			$(source).attr('src', videoElementSrc);
            videoElement.load();
            videoElement.play();
        } else {
			// var srcVideo = $(videoElement).data('src-video');
			$(videoElement).attr('src', videoElementSrc);
		}
    }
    function closePopup() {
        popupBlock.removeClass('active');
        bodyBlock.removeClass('scroll-lock');
        if( popupBlock.is('.video') ){
            videoPause()
        }
    }
    $(document).on('click', popupOpenElement, function(event) {
        event.preventDefault();
        let _this = $(this);
        let id = _this.data('item');
        $(`.popup-block.${id}`).addClass('active').siblings().removeClass('active');
        $('body').addClass('scroll-lock');
        if( popupBlock.is('.video') ){
            videoElement = document.querySelector(`.popup-block.${id} .video-player`);
			videoElementSrc = $(videoElement).data('src-video');
            videoPlay();
        }
    });
    $(document).on('click', popupCloseElement, function(e) {
        closePopup();
    });
    $(document).mouseup(function (e) {
        if(popupBlock.is(":visible") && $(e.target).closest('.popup-block-content').length == 0 && !$(".CybotCookiebotDialogActive")){
            closePopup()
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/popups.js